import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

// 完整路由代码
export default new VueRouter({
  mode: 'hash', // require service suppor
  routes: [
      {
          path: '/',
          redirect: '/home',
          meta: {
            direction: 0
          }
      },
      {
          path: '/home', //登陆页面
          name: 'home',
          /*redirect: 'http://www.heclar.cn/',*/
          component: () => import('@/views/home/home'),
      },
      {
          path: '/news', //登陆页面
          name: 'news',
          component: () => import('@/views/home/news'),
      },
      {
          path: '/traceability', //溯源页面
          name: 'traceability',
          component: () => import('@/views/home/traceability'),
      },
      {
          path: '/blogin', //登陆页面
          name: 'blogin',
          component: () => import('@/views/brandside/blogin'),
      },
      {
          path: '/bhome',
          component: () => import('@/views/Main1'),
          children: [
              {
                  path: '/bhome',
                  name: 'bhome',
                  component: () => import('@/views/brandside/bhome'),
              },
              //经销商-产品录入
              {
                  path: '/bproductentry',
                  name: 'bproductentry',
                  component: () => import('@/views/brandside/bproductentry'),
              },
              //经销商-产品展示
              {
                  path: '/bproductcodeentry',
                  name: 'bproductcodeentry',
                  component: () => import('@/views/brandside/bproductcodeentry'),
              },
              //经销商-经销商管理
              {
                  path: '/bdealermanage',
                  name: 'bdealermanage',
                  component: () => import('@/views/brandside/bdealermanage'),
              },
              //经销商-经销商销售审核
              {
                  path: '/bdealersales',
                  name: 'bdealersales',
                  component: () => import('@/views/brandside/bdealersales'),
              },
              //经销商-订单管理
              {
                  path: '/bordermanage',
                  name: 'bordermanage',
                  component: () => import('@/views/brandside/bordermanage'),
              },
              //经销商-通知与公告
              {
                  path: '/bnotice',
                  name: 'bnotice',
                  component: () => import('@/views/brandside/bnotice'),
              },
          ]
      },
      //经销商-登陆页面
      {
          path: '/dlogin',
          name: 'dlogin',
          component: () => import('@/views/dealer/dlogin'),
      },
      //经销商-主页
      {
          path: '/dhome',
          component: () => import('@/views/Main'),
          children: [
              {
                  path: '/dhome',
                  name: 'dhome',
                  component: () => import('@/views/dealer/dhome'),
              },
              //经销商-个人中心
              {
                  path: '/dpersonalcenter',
                  name: 'dpersonalcenter',
                  component: () => import('@/views/dealer/dpersonalcenter'),
              },
              //经销商-产品展示
              {
                  path: '/dproductsshow',
                  name: 'dproductsshow',
                  component: () => import('@/views/dealer/dproductsshow'),
              },
              //经销商-下单管理
              {
                  path: '/dordermanage',
                  name: 'dordermanage',
                  component: () => import('@/views/dealer/dordermanage'),
              },
              //经销商-销售信息记录
              {
                  path: '/dsalesinformation',
                  name: 'dsalesinformation',
                  component: () => import('@/views/dealer/dsalesinformation'),
              },
              //经销商-积分明细
              {
                  path: '/dpointsdetails',
                  name: 'dpointsdetails',
                  component: () => import('@/views/dealer/dpointsdetails'),
              },
          ]
      },
  ]
})
